import React from 'react';
import { ActivationContainer } from '@/components/pages/Admin/Activation';

export const AdminActivationPage: React.FC = () => {
  return <ActivationContainer />;
};
